import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as fromRoot from 'app/core/store';
import { BookingState } from 'app/core/store/reducers/booking.reducer';
import { AuthService } from 'app/shared/authentication/services/auth.service';
import { ClinicGroupFranchiseSsoInfo } from 'app/shared/clinics/models/clinic-group-franchise-sso-info.model';
import { Identifier } from 'app/shared/storage/services/local-storage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'core-auth-external-sso',
  templateUrl: './external-sso.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ExternalSsoComponent implements OnInit {
  @Input() ssoInfo!: ClinicGroupFranchiseSsoInfo;
  subscription: Subscription = new Subscription();

  constructor(
    private store: Store<fromRoot.State>,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.handleBookingContext();
  }

  private handleBookingContext(): void {
    const regExpServices = new RegExp('^/book-online/booking-reasons/\\d*/services/\\d*');
    const regExpPractitioners = new RegExp('^/book-online/practitioners/\\d*/booking-reasons/\\d*');
    this.subscription.add(
      this.store.pipe(select(fromRoot.getBookingState)).subscribe(bookingState => {
        if (bookingState) {
          const state = JSON.parse(JSON.stringify(bookingState));
          if (
            regExpServices.test(this.router.routerState.snapshot.url) ||
            regExpPractitioners.test(this.router.routerState.snapshot.url)
          ) {
            state.isBooking = true;
          }
          this.authService
            .createBookingDetailsNonce(this.createOtherData(state))
            .subscribe(nonceId => {
              window.location.href = `${this.ssoInfo.providerUri}authorize?client_id=${this.ssoInfo.clientId}&response_type=code&redirect_uri=${window.location.origin}/sso-landing&state=${nonceId}&scope=read`;
            });
        }
      })
    );
  }

  private createOtherData(state: BookingState): any {
    return {
      bookingAppSession: localStorage.getItem(Identifier.TYPE_SOURCE_SESSION_TOKEN),
      practitionerId: state.practitionerId,
      serviceId: state.serviceId,
      startDateTime: state.startDateTime,
      caseId: state.caseId,
      appointmentBookingMode: state.appointmentBookingMode,
      bookingReasonId: state.bookingReasonId,
      treatmentPlanId: state.treatmentPlanId,
      integrationId: state.integrationId,
      partnerToken: state.partnerToken,
      isBooking: state.isBooking,
      sysAppointmentDeliveryMethodId: state.sysAppointmentDeliveryMethodId,
    };
  }
}
